import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { policystreamStore } from '../store/policystreamStore';
import { ProgressStep } from '../components/PolicyStream/components/PolicyStreamProgressBar';
const {
  actions: { setStepStatus, setStepRelevance },
} = policystreamStore;

export const useSetStepStatus = (stepName: ProgressStep['name']) => {
  const dispatch = useDispatch();
  const setStepStatusFunction = useCallback(
    (status: ProgressStep['status']) => {
      dispatch(setStepStatus({ name: stepName, status }));
    },
    [dispatch, stepName],
  );
  return setStepStatusFunction;
};

export const useSetStepRelevance = (stepName: ProgressStep['name']) => {
  const dispatch = useDispatch();
  const setStepRelevanceFunction = useCallback(
    (relevant: ProgressStep['relevant']) => {
      dispatch(setStepRelevance({ name: stepName, relevant }));
    },
    [dispatch, stepName],
  );
  return setStepRelevanceFunction;
};
